export default __webpack_public_path__ + "static/media/keyboard_arrow_right-24px.81d4c4d0.svg";